import BaseChart from './BaseChart';
import { CHART_ANIMATIONS } from '../config/animations';

/**
 * Radar chart implementation using VChart
 */
class RadarChart extends BaseChart {
  /**
   * Get chart specification for radar chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    // Determine fields for indicators and values — auto-detect from data when not provided
    const valueField = this._resolveField('valueField', 'value', ['score', 'amount', 'count', 'metric'])
      || this._resolveValueField();
    const categoryField = this._resolveField('categoryField', 'category', ['name', 'label', 'dimension', 'axis', 'indicator'])
      || this._resolveNameField();
    
    // Get series field for multiple radar shapes
    const seriesField = this.options.seriesField;
    
    return {
      type: 'radar',
      data,
      valueField,
      categoryField,
      seriesField,
      
      // Coordinate system configuration
      polarAxis: {
        visible: true,
        type: 'line',
        style: {
          stroke: '#E8E8E8',
          lineWidth: 1,
          ...this.options.polarAxisStyle
        }
      },
      
      // Radar specific styling
      radar: {
        style: {
          lineWidth: 2,
          fillOpacity: 0.3,
          ...this.options.radarStyle
        },
        state: {
          hover: {
            fillOpacity: 0.5
          },
          ...this.options.radarState
        }
      },
      
      // Point markers configuration
      point: {
        visible: this.options.showPoints !== false,
        style: {
          size: 4,
          fillOpacity: 1,
          stroke: '#fff',
          lineWidth: 1,
          ...this.options.pointStyle
        },
        state: {
          hover: {
            size: 6,
            stroke: '#fff',
            lineWidth: 2
          },
          ...this.options.pointState
        },
        ...this.options.point
      },
      
      // Label configuration
      label: {
        visible: this.options.showLabels === true,
        position: this.options.labelPosition || 'top',
        style: {
          fontSize: 12,
          fontWeight: 'normal',
          ...this.options.labelStyle
        },
        formatter: this.options.labelFormatter
      },
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
}

export default RadarChart; 